import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DomoticaService } from 'src/app/services/domotica/domotica.service';
import { NavigatorService } from 'src/app/services/navigator.service';
import { TenantDTO } from 'src/app/shared/dto/domain/tenant';
import { ConfirmationDialogComponent } from '../../shared/confirmation-dialog/confirmation-dialog.component';
import { Icon } from './downstairs-door-widget.model';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: "app-downstairs-door-widget",
  templateUrl: "./downstairs-door-widget.component.html",
  styleUrls: ["./downstairs-door-widget.component.scss"],
})
export class DownstairsDoorWidgetComponent implements OnInit, OnDestroy {
  tenant: TenantDTO;
  downstairsIcon: Icon;

  private _showWidget: boolean = false;

  constructor(
    private domoticaService: DomoticaService,
    private navigatorService: NavigatorService,
    private confirmDialog: MatDialog,
    private snackBar: MatSnackBar,
	private iconRegistry: MatIconRegistry,
	private sanitizer: DomSanitizer,
  ) {
	iconRegistry.addSvgIcon("downstairs-door",        sanitizer.bypassSecurityTrustResourceUrl("assets/img/icons/downstairs-door.svg"));
	this.downstairsIcon = {
	  code: "downstairs-door",
	  colorClass: "downstairs",
	  statusLabel: "Downstairs",
	  secondLabel: "Downstairs",
	};

  }

  ngOnInit(): void {
    this.navigatorService.tenant.subscribe((res: TenantDTO) => this.tenant = res);
	this.navigatorService.getCustomConfiguration().subscribe((c: any) => {
	  if(c?.officeDoorStatusWidgetEnable != null) {
	    this._showWidget = c.officeDoorStatusWidgetEnable;
	  }
	});
  }

  get showWidget() {
    return this._showWidget;
  }

  doCommand() {
      this.execCommand(); 
  }

  private execCommand(): void {
    this.confirmDialog.open(ConfirmationDialogComponent, {
      data: `Sei sicuro di voler dare il tiro?`
    }).afterClosed().subscribe(result => {
      if (result) {
        this.domoticaService.downstairsDoorCommand().subscribe({
          error: (error) => {
            const msg = error?.status === 409
              ? "Un comando è già in esecuzione, riprova tra qualche secondo."
              : "Errore nell'apertura del portone.";
            this.snackBar.open(msg, null, { duration: 3000 });
          }
        });
      }
    });
  }

  ngOnDestroy(): void {
  }
}
